import * as React from 'react'
import type { CountryCode } from '@repo/graphql-types'
import { COUNTRY_COOKIE_NAME, REGION_COOKIE_NAME } from 'constants/cookies'
import { getCookie } from 'utils/dom'

export const EUCountries = new Set([
  'AT',
  'BE',
  'BA',
  'BG',
  'HR',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MD',
  'NL',
  'PL',
  'PT',
  'RO',
  'RS',
  'SK',
  'SI',
  'ES',
  'SE',
  'CH',
  'TR',
  'UA',
])

export const EUAndUKCountries = new Set([...EUCountries, 'GB'])

export const TIER_ONE_COUNTRIES = new Set([...EUCountries, 'AU', 'US', 'CA', 'NZ'])

/*
Besides the ISO-3166-1 alpha-2 codes, Cloudflare uses the following special country codes:
  XX - Used for clients without country code data.
  T1 - Used for clients using the Tor network.
*/
type CLOUDFLARE_COOKIES_VALUES = CountryCode | 'XX' | 'T1'

export const useUserLocation = () => {
  const [locationSet, setLocationSet] = React.useState(false)
  const [cookieCountry, setCookieCountry] = React.useState<CLOUDFLARE_COOKIES_VALUES | undefined>()
  const [cookieRegion, setCookieRegion] = React.useState<string | undefined>()

  React.useEffect(() => {
    const countryCookieValue = getCookie(COUNTRY_COOKIE_NAME)
    if (countryCookieValue.length > 0) {
      setCookieCountry(countryCookieValue as CLOUDFLARE_COOKIES_VALUES)
    }

    const regionCookieValue = getCookie(REGION_COOKIE_NAME)
    if (regionCookieValue.length > 0) {
      setCookieRegion(regionCookieValue)
    }

    setLocationSet(true)
  }, [])

  const isUserFromTierOne = TIER_ONE_COUNTRIES.has(cookieCountry ?? '')
  const isUserFromEUOrUK = EUAndUKCountries.has(cookieCountry ?? '')

  return {
    locationSet,
    country: cookieCountry,
    region: cookieRegion,
    isUserFromTierOne,
    isUserFromEUOrUK,
  }
}
